import styled from "styled-components"

export const Container = styled.div`
    margin: 0 auto;
    padding: 0 20px;

    h1 {
        color: var(--lightGrey);
    }
`

export const Wrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    grid-gap: 30px;
`